import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getCardIconType,
  getCardsIcon,
  getCardTitle,
} from "../../trainer-member-map/tmeMocksData";
import CalendarLoader from "../../../common-components/CalendarLoader";

const TMECheckinAnalysis = () => {
  const {
    tmeCheckinAnalysis,
    tmeCheckinAnalysisError,
    tmeCheckinAnalysisLoading,
  } = useSelector((state) => state.prospects);

  const [statsData, setStatsData] = useState(null);

  useEffect(() => {
    if (
      !tmeCheckinAnalysisLoading &&
      !tmeCheckinAnalysisError &&
      tmeCheckinAnalysis?.status &&
      tmeCheckinAnalysis?.stats
    ) {
      setStatsData(tmeCheckinAnalysis.stats);
    } else {
      setStatsData(null);
    }
  }, [tmeCheckinAnalysisLoading, tmeCheckinAnalysisError, tmeCheckinAnalysis]);

  return (
    <div className="mr-kpi-grid grid-4 mt30">
      {tmeCheckinAnalysisLoading ? (
        <CalendarLoader daysCount={6} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, data]) => {
          const cardTitle = data?.label || getCardTitle(key);
          const cardValue = data?.count ?? data?.value ?? 0;
          const cardSubtitle = data?.description || "";

          return (
            <div className="mr-kpi-card" key={key}>
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">{cardTitle}</p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">{cardValue}</div>
                  </div>

                  {cardSubtitle && (
                    <div className="mr-kpi-subtitle">{cardSubtitle}</div>
                  )}
                </div>
                <span
                  className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(key)}`}
                >
                  {getCardsIcon(key)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default TMECheckinAnalysis;
